import { render, staticRenderFns } from "./page-sign-up.vue?vue&type=template&id=19bedf4a&scoped=true"
import script from "./page-sign-up.vue?vue&type=script&lang=js"
export * from "./page-sign-up.vue?vue&type=script&lang=js"
import style0 from "./page-sign-up.vue?vue&type=style&index=0&id=19bedf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bedf4a",
  null
  
)

export default component.exports